module.exports = __webpack_public_path__ + "img/screenshot-5.e714fd86.webp";